import { injectStyle } from '__style_helper__'
injectStyle(".cSWZVW_board{gap:var(--gap-sm);padding:var(--gap-md);border-radius:var(--gap-md);border:1px solid #fff3;flex-direction:column;display:flex}")
export default {"board":"cSWZVW_board",}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIiJdLCJtYXBwaW5ncyI6IkEifQ==